const PRICE_LIST = [
  { id: 1, price: 50000 },
  { id: 2, price: 100000 },
  { id: 3, price: 150000 },
  { id: 4, price: 200000 },
  { id: 5, price: 250000 },
];

export default PRICE_LIST;
